import { createStore, applyMiddleware, compose } from 'redux';
// import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';

const middlewares = [
  // createLogger(),
  thunk
];

export default createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(...middlewares),
    // window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)



// WEBPACK FOOTER //
// ./src/store/index.js